// components/Header.js
import React, { useState } from 'react';
import { FaFacebook } from 'react-icons/fa'; 

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <a href="#home" onClick={closeMenu}>
              <img
                src="/logoblue.png"
                alt="Sunsight Energy Logo"
                style={{
                  height: '80px',
                  width: 'auto'
                }}
              />
            </a>
          </div>
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul>
              <li><a href="#home" onClick={closeMenu}>Home</a></li>
              <li><a href="#about" onClick={closeMenu}>About</a></li>
              <li><a href="#services" onClick={closeMenu}>Services</a></li>
              <li><a href="#team" onClick={closeMenu}>Team</a></li>
              <li><a href="#contact" onClick={closeMenu}>Contact</a></li>
              <li>
  <a 
    href="https://www.facebook.com/sunsightenergymw" 
    target="_blank" 
    rel="noopener noreferrer"
    onClick={closeMenu}
  >
    <FaFacebook style={{ marginRight: '6px' }} />
    Facebook
  </a>
</li>
            </ul>
          </nav>
          <div 
            className={`menu-toggle ${isMenuOpen ? 'active' : ''}`} 
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;